import React from 'react';
import { clockIcon } from '@chordbaker/design';

interface ClockIconProps {
  size?: number;
  color?: string;
  className?: string;
}

const ClockIcon: React.FC<ClockIconProps> = ({
  size = clockIcon.defaultSize,
  color = 'currentColor',
  className = '',
}) => {
  const circle = clockIcon.elements[0] as { cx: number; cy: number; r: number };
  const polyline = clockIcon.elements[1] as { points: string };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={clockIcon.viewBox}
      fill={clockIcon.fill}
      stroke={color}
      strokeWidth={clockIcon.strokeWidth}
      strokeLinecap={clockIcon.strokeLinecap as React.SVGAttributes<SVGSVGElement>['strokeLinecap']}
      strokeLinejoin={clockIcon.strokeLinejoin as React.SVGAttributes<SVGSVGElement>['strokeLinejoin']}
      className={className}
    >
      <circle cx={circle.cx} cy={circle.cy} r={circle.r} />
      <polyline points={polyline.points} />
    </svg>
  );
};

export default ClockIcon;
